import React from 'react';
import cx from 'classnames';
import withExtensionContextConsumer from '../hoc/withExtensionContextConsumer';
import { hexToCssHex } from '../utils';

// eslint-disable-next-line react/prop-types
const AppointmentContainer = ({ children, danger, extension = {} }) => (
  <div
    style={{ borderTopColor: hexToCssHex(extension.primaryColor) }}
    className={cx('c-notification-content', { 'c-notification-content--danger': danger })}
  >
    {children}
  </div>
);

export default withExtensionContextConsumer(AppointmentContainer);



// WEBPACK FOOTER //
// ./src/app/notifications/shared/AppointmentContainer.jsx